import React,{useEffect, useState} from 'react'
import { toast } from 'react-hot-toast'
import { TextInput } from '../../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import SettingsMenu from '../../staticscreens/SettingsMenu'
import GoBack from '../../../components/back/GoBack'
import { ButtonFilledAutoWidth } from '../../../components/button'
import { CreateCaseStageService, UpdateCaseStageService } from '../../../services/CaseStageService'
import { FilterCaseTypeService } from '../../../services/CaseTypeService'
import { Select } from 'antd'

function CaseStageCE() {
 
  const [data,setdata] = useState({name:'',case_type:''});  
  const [error,seterror] = useState({name:'',case_type:''}); 
  const [caseTypeArr,setcaseTypeArr] = useState([])
  
  const {state} = useLocation();
  const navigate = useNavigate();

  // const {id,department_name} = state;


  useEffect(()=>{
    if(state?._id !== null && state?._id !== undefined){
      
      let d = state 
      let passData = {
        name:d?.name  
      }
      if(d?.case_type?._id !== undefined){
          passData['case_type'] = {label:d?.case_type?.name,value:d?.case_type?._id}
      }
      setdata({...passData})
    }

  },[state])

  function handlechange(e){
    setdata({...data,[e.target.name] : e.target.value})
    seterror({...error,[e.target.name]:''})
  }

  async function submitform(){
    if(!data.name){
        seterror({...error,name:'Case Type Name field is required *'})
    }else{

      let sendData = {...data}

      if(data?.case_type?.value !== undefined){
        sendData['case_type'] = data?.case_type?.value
      }


        if(state?._id === undefined || state?._id === null){
        const response = await CreateCaseStageService(sendData)
        if (response.status === 201) {
          setdata({...data,name:'',case_type:''})
          seterror({...error,name:'',case_type:''})
          toast.success('Case Stage Created Successfully')
        }   
        // console.log("response?.data?.errors",response?.data?.errors)
        if(response.status === 422){
          seterror({...error,name:response?.data?.errors?.sendData})
        } 
      }else{
        const response = await UpdateCaseStageService(sendData,state?._id)
        if (response.status === 200) {
          setdata({...data,name:'',case_type:''})
          seterror({...error,name:'',case_type:''})
          navigate(-1)
          toast.success('Case Stage Updated Successfully')
        }   
        if(response.status === 422){
          seterror({...error,name:response?.data?.errors?.name})
        } 
      }
  }
  }

  async function searchData(e,type){
    if(type == 'case_type'){
      const response = await FilterCaseTypeService(e,1)
      let datas = response?.data?.datas
      if(datas?.length > 0){
      let arr = []
      datas?.forEach((d)=>{
        arr.push({label:d?.name,value:d?._id})
      })
      setcaseTypeArr(arr)
      }
    }
  }

  async function handleselect(e,type){
    if(type == 'case_type'){
     let dataFind = caseTypeArr.find((f)=>f?.value === e)
     setdata({...data,[type]:dataFind})
    }
  }

  return (
    <div className='md:flex '>

    <div className='hidden md:block'>
    <SettingsMenu />
    </div> 
 
  <div className='sm:w-full lg:w-72 px-4 pt-5' >


      <GoBack /> 
      

        <h6 className='font-bold'>{(state?._id !== null && state?._id !== undefined) ? 'Edit' : 'Add'}  Case Stage</h6>
        <h6 className='text-[10px] bg-slate-100 p-2 font-[500] leading-snug' >Use the below form to create or edit the <b> Case Stage</b> for your company employees.</h6>
     
        <h6 className='text-[11px] mt-2 font-[400] mb-1' >Case Type</h6>
        <Select 
          value={data.case_type}
          options={caseTypeArr}
          allowClear={true}
          bordered={false}
          showSearch={true}
          onSearch={(e)=>searchData(e,'case_type')}
          onChange={e=>{handleselect(e,'case_type')}}
          className='w-[100%] border border-l-4 border-l-slate-800 border-slate-300'
        />

        <TextInput 
            label={'Case Stage'}  
            variant="standard"
            name="name"
            type="text"
            error={error.name}
            value={data.name}
            handlechange={handlechange}
            placeholder="Enter your Case Stage name"
            InputLabelProps={{
                style: { color: '#fff', }, 
            }}/>

        <div className='mt-5'>
        <ButtonFilledAutoWidth btnName={(state?._id !== null && state?._id !== undefined) ? "UPDATE CASE STAGE" : "ADD CASE STAGE"}  onClick={submitform} />  
        </div>


    </div>
    </div>
  )
}

export default CaseStageCE